import { Link } from 'react-router-dom';
import { ARTICLES, formatArticleDate } from '../../data/articles';
import Reveal from '../ui/Reveal';
import { ArrowRight, Clock } from '../ui/Icons';

/** Editorial row: one large article with its copy boxed over the cover, two stacked beside it. */
const LatestStories = () => {
  const [lead, ...rest] = ARTICLES.slice(0, 5);
  return (
    <section className="vp-section bg-brand-surface">
      <div className="container">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5 mb-10">
          <div className="max-w-2xl">
            <span className="vp-eyebrow">The Vertex journal</span>
            <h2 className="vp-heading mt-4 text-3xl sm:text-4xl lg:text-[2.75rem]">Ideas, advice and know-how</h2>
            <p className="mt-4 text-brand-muted leading-relaxed">Practical guidance from the people who make the paint — finishes, colour, surface prep and keeping water out.</p>
          </div>
          <Link to="/blog" className="vp-btn vp-btn-outline self-start flex-shrink-0">
            All articles
            <ArrowRight />
          </Link>
        </div>

        <div className="grid lg:grid-cols-12 gap-5">
          <Reveal className="lg:col-span-7">
            <Link to={`/blog/${lead.slug}`} className="group relative block h-[440px] lg:h-full min-h-[440px] rounded-3xl overflow-hidden">
              <img src={lead.cover} alt={lead.coverAlt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1200ms] ease-premium group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/60 to-transparent" />
              <div className="absolute left-4 right-4 bottom-4 sm:left-6 sm:right-auto sm:bottom-6 sm:max-w-lg bg-white rounded-2xl shadow-lift p-6">
                <span className="vp-chip vp-chip-red">{lead.category}</span>
                <h3 className="mt-3 text-xl sm:text-2xl font-bold text-brand-ink leading-snug group-hover:text-brand-blue transition-colors">{lead.title}</h3>
                <p className="mt-2 text-sm text-brand-muted line-clamp-2">{lead.excerpt}</p>
                <p className="mt-3 flex items-center gap-2 text-xs text-brand-muted">
                  <Clock size={13} /> {lead.readingTime} min read · {formatArticleDate(lead.date)}
                </p>
              </div>
            </Link>
          </Reveal>

          <div className="lg:col-span-5 grid sm:grid-cols-2 lg:grid-cols-1 gap-5">
            {rest.slice(0, 4).map((a, i) => (
              <Reveal key={a.slug} delay={(Math.min(i + 1, 4) as 1 | 2 | 3 | 4)}>
                <Link to={`/blog/${a.slug}`} className="vp-card group flex gap-4 p-3 h-full">
                  <span className="relative w-28 sm:w-32 flex-shrink-0 rounded-xl overflow-hidden">
                    <img src={a.cover} alt="" loading="lazy" className="vp-zoom absolute inset-0 w-full h-full object-cover" />
                  </span>
                  <span className="py-1 pr-2 min-w-0">
                    <span className="text-[11px] font-bold tracking-wider uppercase text-brand-red">{a.category}</span>
                    <span className="block mt-1 text-[15px] font-semibold text-brand-ink leading-snug line-clamp-2 group-hover:text-brand-blue transition-colors">{a.title}</span>
                    <span className="block mt-1.5 text-xs text-brand-muted">{a.readingTime} min read</span>
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestStories;
